import { Form as FinalForm, Field } from "react-final-form";
import { Form, Button, Grid, Segment } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { IBrokerFilter } from "../../../app/models/report";
import SelectInputOnSearchChange from "../../../app/common/form/SelectInputOnSearchChange";
import DateInput from "../../../app/common/form/DateInput";
import { useContext, useState } from "react";
import React from "react";

const BrokerFilter = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    brokerFilter,
    btFilterBroker,
    getBrokersAutocomplete,
    brokersAutocomplete,
    setBrokerFilter,
    getTenantsAutocomplete,
    tenantsAutocomplete,
  } = rootStore.reportStore;

  const [brokerFilterForm] = useState<IBrokerFilter>({
    brokerId: brokerFilter.brokerId,
    tenantId: brokerFilter.tenantId,
    dateFrom: brokerFilter.dateFrom,
    dateTo: brokerFilter.dateTo,
  });

  const handleFinalFormSubmit = (values: any) => {
    setBrokerFilter(values);
  };

  const handleBroker = async (value: any) => {
    getBrokersAutocomplete(value);
  };

  const handleTenant = async (value: any) => {
    getTenantsAutocomplete(value);
  };

  return (
    <Segment className="grayborder">
      <FinalForm
        initialValues={brokerFilterForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <div className="filter">
              <Grid relaxed doubling columns={2}>
                <Grid.Row columns={3}>
                  <Grid.Column>
                    <label>Agente</label>
                    <Field
                      name="brokerId"
                      value={brokerFilterForm.brokerId}
                      component={SelectInputOnSearchChange}
                      search={true}
                      autoComplete="off"
                      options={brokersAutocomplete}
                      onSearchChange={handleBroker}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <label>Cliente</label>
                    <Field
                      name="tenantId"
                      value={brokerFilterForm.tenantId}
                      component={SelectInputOnSearchChange}
                      search={true}
                      autoComplete="off"
                      options={tenantsAutocomplete}
                      onSearchChange={handleTenant}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <label>Fecha consumo (dd/mm/yyyy)</label>
                    <Form.Group widths="equal">
                      <Field
                        name="dateFrom"
                        placeholder="desde"
                        value={brokerFilterForm.dateFrom}
                        component={DateInput}
                      />
                      <Field
                        name="dateTo"
                        placeholder="hasta"
                        value={brokerFilterForm.dateTo}
                        component={DateInput}
                      />
                    </Form.Group>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <br />
              <Button
                loading={btFilterBroker}
                disabled={btFilterBroker}
                className="ui primary button filterbutton"
                color="blue"
                type="submit"
                content="Buscar"
              />
            </div>
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(BrokerFilter);
